module.exports = __webpack_public_path__ + "static/media/acramite_50ws.b1fa0987.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/acramite_50ws.png
// module id = 1029
// module chunks = 3